<template>
  <div class="my-2">
    <!-- Normal text -->
    <p
      v-if="row.rowType === 'STRING'"
      class="leading-relaxed"
      v-html="row.rowContent"
     />
      <!-- {{ row.rowContent }} -->
    <!-- </p> -->

    <!-- Math formula -->
    <p
      v-else-if="row.rowType === 'FORMULA'"
      ref="mathEl"
      class="leading-relaxed"
      v-html="mathContent"
    />

    <!-- Image -->
    <img
      v-else-if="row.rowType === 'IMAGE'"
      :src="imageSrc"
      class="max-w-full rounded-lg border"
      alt="Question image"
    />

    <p v-else class="text-red-600 text-sm">
      Unsupported rowType: {{ row.rowType }}
    </p>
  </div>
</template>

<script setup>
import { computed, ref, watch, onMounted, nextTick } from "vue";

const props = defineProps({
  row: { type: Object, required: true }
});

const mathEl = ref(null);

const imageSrc = computed(() => {
  if (props.row.base64Content) {
    return `data:image/jpeg;base64,${props.row.base64Content}`;
  }
  return props.row.rowContent;
});

/**
 * Wrap formula in MathJax delimiters
 * Example input: x^2 + \sqrt{9}
 */
const mathContent = computed(() => {
  return `\\(${props.row.formulaContent}\\)`;
});

const typesetMath = async () => {
  if (window.MathJax && mathEl.value) {
    await nextTick();
    window.MathJax.typesetPromise([mathEl.value]);
  }
};

onMounted(typesetMath);
watch(() => props.row.rowContent, typesetMath);
</script>
